import { CSSBase, standard, ThemeContext, Toaster } from '@creditas-ui/react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { GlobalContext } from '@/shared/infrastructure/context';
import { MainLayout } from '@/shared/ui';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from '@/shared/infrastructure/clients/apollo';
import { Router } from './Router';
import { oidcConfig } from './auth/oidc/oidcConfig';

import { AuthProvider } from 'react-oidc-context';
import { customStyles } from './shared/ui/Layout/styles';

const AppContent: React.FC<any> = (props) => {
  const location = useLocation();
  const isSkeletonActive =
    location.pathname === '/auth/redirect_sso' || location.pathname === '/auth/sso-btg';

  return (
    <ThemeContext.Provider value={{ ...standard }}>
      <GlobalContext>
        <ApolloProvider client={apolloClient}>
          <MainLayout skeleton={isSkeletonActive}>
            <CSSBase custom={customStyles} />
            <Router {...props} />
            <Toaster />
          </MainLayout>
        </ApolloProvider>
      </GlobalContext>
    </ThemeContext.Provider>
  );
};

const App: React.FC<any> = (props) => {
  return (
    <AuthProvider {...(oidcConfig as any)}>
      <BrowserRouter>
        <AppContent {...props} />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
